import { Box } from "@mui/material";
import { useState } from "react";
import React from "react";
import EditableInputCell from "./EditableInputCell";
import EllipsisedCell from "./EllipsisedCell";

export default function EditableMRTCell({
  value,
  handleEdit,
}: {
  value: string;
  handleEdit: (newValue: string) => void;
}) {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  if (isEditing) {
    return (
      <EditableInputCell
        initialValue={value === "-" ? "" : value}
        onEdit={(newValue) => {
          handleEdit(newValue as string);
          setIsEditing(false);
        }}
      />
    );
  }
  return (
    <Box
      onClick={() => setIsEditing(true)}
      sx={{
        cursor: "pointer",
        width: "100%",
      }}
    >
      <EllipsisedCell value={value} type="text" />
    </Box>
  );
}
